import { Controller } from "stimulus";
import { jsonFetch } from "helpers/json_fetch";

export default class extends Controller {
  static targets = ["text", "icon"];

  submit(e) {
    e.preventDefault();

    const url = this.data.get("url");
    const saved = this.data.has("saved");
    const method = saved ? "DELETE" : "POST";

    this._disable();
    jsonFetch(url, { method })
      .catch(this._handleError)
      .then(json => {
        this.markAsSaved({ saved: json.saved });
        this._dispatchSaveEvent(json);
        this._enable();
      })
  }

  markAsSaved({ saved = true }) {
    const classes = this.element.classList;
    classes.toggle("btn-third", !saved);
    classes.toggle("btn-light", saved);

    this.textTarget.innerText = saved
      ? this.data.get("textSaved")
      : this.data.get("textUnsaved");

    if (saved) {
      this.data.set("saved", true);
    } else {
      this.data.delete("saved");
    }
  }

  _handleError = (response) => {
    if (response.status == 401) {
      window.location = this.data.get("authUrl")
    } else {
      console.error("Unknown error", response)
    }
    return response
  }

  _disable() {
    this.element.disabled = true;
    this.iconTarget.classList.add("a-spin--on-with-delay");
    this.iconTarget.classList.remove("a-float");
  }

  _enable() {
    this.element.disabled = false;
    this.iconTarget.classList.remove("a-spin--on-with-delay");
    this.iconTarget.classList.add("a-float");
  }

  _dispatchSaveEvent(data) {
    if (!data.saved) return

    window.dispatchEvent(new CustomEvent("cults:saved"));
  }
}
